var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lockScreen}},[_c('Tooltip',{attrs:{"content":"锁屏","placement":"bottom"}},[_c('Icon',{attrs:{"type":"locked","size":20}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }